import { FormRenderProps } from 'components/form'
import { AldeiaSelectFieldModel } from 'components/form/field/select/AldeiaSelectField'
import { BairroSelectFieldModel } from 'components/form/field/select/BairroSelectField'
import { CboSelectModel } from 'components/form/field/select/CboSelectField'
import { DseiSelectFieldModel } from 'components/form/field/select/DseiSelectField'
import { EtniaSelectFieldModel } from 'components/form/field/select/EtniaSelectField'
import { FichaNotificacaoSelectModel } from 'components/form/field/select/FichasNotificacaoCasoSuspeitoSelectField'
import { LogradouroSelectModel } from 'components/form/field/select/LogradouroSelectField'
import { MunicipioSelectModel } from 'components/form/field/select/MunicipioSelectField'
import { PaisSelectFieldModel } from 'components/form/field/select/PaisSelectField'
import { PoloBaseSelectFieldModel } from 'components/form/field/select/PoloBaseSelectField'
import { UfSelectModel } from 'components/form/field/select/UfSelectField'
import { PovoComunidadeTradicionalEnum } from 'graphql/types.generated'
import { ReactNode } from 'react'
import { metaPath } from 'util/metaPath'
import { ValidatorFunction } from 'util/validation'

import {
  EscolaridadeSinan,
  GestanteSinan,
  IdentidadeGeneroSinan,
  MotivoAusenciaCpfSinan,
  OrientacaoSexualSinan,
  RacaCorSinan,
  SexoSinan,
  SimNaoSinan,
  TipoDeficienciaSinan,
  ZonaSinan,
} from './model-sinan'

export const gestanteSinanRecord: Record<GestanteSinan, string> = {
  NAO: 'Não',
  NAO_SE_APLICA: 'Não se aplica',
  IDADE_GESTACIONAL_IGNORADA: 'Idade gestacional ignorada',
  PRIMEIRO_TRIMESTRE: '1º trimestre',
  SEGUNDO_TRIMESTRE: '2º trimestre',
  TERCEIRO_TRIMESTRE: '3º trimestre',
}

export const motivoAusenciaCpfSinanRecord: Record<MotivoAusenciaCpfSinan, string> = {
  PACIENTE_DESACORDADO_SEM_DOCUMENTOS: 'Paciente desacordado, sem documentos',
  RECEM_NASCIDO: 'Recém-nascidos',
  INDIGENA_SEM_CPF: 'Indígenas sem CPF',
  SITUACAO_RUA_SEM_DOCUMENTOS: 'Pessoa em situação de rua sem documentos',
  RECUSA_CULTURAL_RELIGIOSA_OU_OUTRO: 'Recusa por cultura, religião ou outro motivo',
  ESTRANGEIRO_EM_TRANSITO: 'Estrangeiro em trânsito (turista/visitante)',
  CRIANCA_SEM_DOCUMENTACAO_EMITIDA: 'Crianças sem documentação emitida',
  ESTRANGEIRO_RESIDENTE_SEM_CPF: 'Estrangeiro residente sem CPF',
  INTERNACAO_COMPULSORIA: 'Internação compulsória (saúde mental ou ordem judicial)',
  POPULACAO_MIGRANTE_REFUGIADA_EM_REGULARIZACAO: 'População migrante/refugiada em processo de regularização',
  SITUACAO_CALAMIDADE_OU_DESASTRE: 'Situações de calamidade ou desastre',
}

export const racaCorSinanRecord: Record<RacaCorSinan, string> = {
  BRANCA: 'Branca',
  PRETA: 'Preta',
  AMARELA: 'Amarela',
  PARDA: 'Parda',
  INDIGENA: 'Indígena',
}

export const identidadeGeneroSinanRecord: Record<IdentidadeGeneroSinan, string> = {
  MULHER_CIS: 'Mulher cisgênero',
  HOMEM_CIS: 'Homem cisgênero',
  MULHER_TRANS: 'Mulher transgênero',
  HOMEM_TRANS: 'Homem transgênero',
  TRAVESTI: 'Travesti',
  NAO_BINARIO: 'Não-binário',
  NAO_SE_APLICA: 'Não se aplica',
}

export const orientacaoSexualSinanRecord: Record<OrientacaoSexualSinan, string> = {
  HETEROSSEXUAL: 'Heterossexual',
  HOMOSSEXUAL: 'Homossexual (gay/lésbica)',
  BISSEXUAL: 'Bissexual',
  ASSEXUAL: 'Assexual',
  PANSEXUAL: 'Pansexual',
  NAO_SE_APLICA: 'Não se aplica',
}

export const escolaridadeSinanRecord: Record<EscolaridadeSinan, string> = {
  PRE_ESCOLA_INFANTIL: 'Pré-escola/educação infantil',
  FUNDAMENTAL_INCOMPLETO: 'Ensino fundamental incompleto',
  FUNDAMENTAL_COMPLETO: 'Ensino fundamental completo',
  MEDIO_INCOMPLETO: 'Ensino médio incompleto',
  MEDIO_COMPLETO: 'Ensino médio completo',
  SUPERIOR_INCOMPLETO: 'Ensino superior incompleto',
  SUPERIOR_COMPLETO: 'Ensino superior completo',
  NAO_INFORMADO: 'Não informado',
  NAO_SE_APLICA: 'Não se aplica',
}

export const tipoDeficienciaSinanRecord: Record<TipoDeficienciaSinan, string> = {
  FISICA: 'Física',
  AUDITIVA: 'Auditiva',
  VISUAL: 'Visual',
  MENTAL: 'Mental',
  INTELECTUAL: 'Intelectual',
  TEA: 'Transtorno do Espectro Autista (TEA)',
  PSICOSSOCIAL: 'Psicossocial',
}

export const zonaSinanRecord: Record<ZonaSinan, string> = {
  URBANA: 'Urbana',
  RURAL: 'Rural',
  PERIURBANA: 'Periurbana',
  SILVESTRE: 'Silvestre',
}

export const NOME_MAX_LENGTH = 70

export interface DadosIdentificacaoFormModel {
  dataNotificacao?: LocalDate
  nome?: string
  nomeSocial?: string
  cpf?: string
  stNaoPossuiCpf?: boolean
  cns?: string
  justificativaNaoPossuiCpf?: MotivoAusenciaCpfSinan
  dataNascimento?: LocalDate
  sexo?: SexoSinan
  estrangeiro?: SimNaoSinan
  paisNascimento?: PaisSelectFieldModel
  municipioNascimento?: MunicipioSelectModel
  racaCor?: RacaCorSinan
  isCidadaoAldeado?: SimNaoSinan
  dsei?: DseiSelectFieldModel
  etnia?: EtniaSelectFieldModel
  poloBase?: PoloBaseSelectFieldModel
  aldeia?: AldeiaSelectFieldModel
  nomePai?: string
  desconheceNomePai?: boolean
  nomeMae?: string
  desconheceNomeMae?: boolean
  identidadeGenero?: IdentidadeGeneroSinan
  orientacaoSexual?: OrientacaoSexualSinan
  isMembroComunidadeTradicional?: SimNaoSinan
  povoComunidadeTradicional?: PovoComunidadeTradicionalEnum
  gestante?: GestanteSinan
}

export interface EnderecoResidenciaFormModel {
  /** Sem fonte de dados no PEC — ver TODO no EnderecoResidenciaSection. */
  regiaoAdministrativa?: string
  cep?: string
  uf?: UfSelectModel
  logradouro?: LogradouroSelectModel
  numero?: string
  semNumero?: boolean
  complemento?: string
  bairro?: BairroSelectFieldModel
  municipio?: MunicipioSelectModel
  zona?: ZonaSinan
  pais?: PaisSelectFieldModel
}

export interface DadosIndividuoFormModel {
  escolaridade?: EscolaridadeSinan
  ocupacao?: CboSelectModel
  /** Sem fonte de dados no PEC — ver TODO no DadosIndividuoStep. */
  atividadeEconomicaCnae?: string
  isProfissionalSaude?: SimNaoSinan
  possuiDeficiencia?: SimNaoSinan
  tipoDeficiencia?: TipoDeficienciaSinan
  endereco?: EnderecoResidenciaFormModel
  isPessoaSituacaoRua?: SimNaoSinan
  isPessoaPrivadaLiberdade?: SimNaoSinan
  telefone?: string
}

export interface Cid10NotificacaoAgravoModel {
  id: ID
  nome: string
  codigo: string
}

export interface DadosClinicosFormModel {
  agravosSuspeitos?: ReadonlyArray<FichaNotificacaoSelectModel>
  agravosConfirmados?: ReadonlyArray<FichaNotificacaoSelectModel>
  /** Sem fonte de dados no PEC (tabela MedDRA) — ver TODO no DadosClinicosStep. */
  sinaisSintomas?: ReadonlyArray<string>
  outrosSinaisSintomas?: string
  dataInicioSintomas?: LocalDate
  dataDiagnostico?: LocalDate
  dataAtendimento?: LocalDate
  isDoencaRelacionadaTrabalho?: SimNaoSinan
  isDoencaRelacionadaDesastre?: SimNaoSinan
}

export interface IdNomeNotificacaoModel {
  id: ID
  nome: string
}

export interface NotificacaoFormModel {
  unidadeSaude?: IdNomeNotificacaoModel
  municipio?: IdNomeNotificacaoModel
  uf?: IdNomeNotificacaoModel
}

export interface NotificacaoAgravoFormModel {
  dadosIdentificacao?: DadosIdentificacaoFormModel
  dadosIndividuo?: DadosIndividuoFormModel
  dadosClinicos?: DadosClinicosFormModel
  notificacao?: NotificacaoFormModel
}

export interface NotificacaoAgravoStep {
  title: string
  render: (formProps: FormRenderProps<NotificacaoAgravoFormModel>) => ReactNode
  validator?: ValidatorFunction<NotificacaoAgravoFormModel>
}

export const metaNotificacaoAgravo = metaPath<NotificacaoAgravoFormModel>()
